import React from "react";
import { vibeFor } from "../lib/slotVibe";

/* Lotus + diya ornament (Mahalakshmi motif) */
export function Lotus({ className = "", color = "#fde68a" }) {
  return (
    <svg viewBox="0 0 100 60" className={className} fill="none" aria-hidden>
      <path d="M50 58 C38 50 30 40 30 28 C30 20 40 14 50 6 C60 14 70 20 70 28 C70 40 62 50 50 58Z" fill={color} opacity=".9" />
      <path d="M50 58 C34 54 22 44 18 30 C26 26 36 28 44 36 C40 44 44 52 50 58Z" fill={color} opacity=".7" />
      <path d="M50 58 C66 54 78 44 82 30 C74 26 64 28 56 36 C60 44 56 52 50 58Z" fill={color} opacity=".7" />
      <path d="M50 58 C30 58 14 50 6 40 C16 36 30 40 40 48 C44 52 47 56 50 58Z" fill={color} opacity=".5" />
      <path d="M50 58 C70 58 86 50 94 40 C84 36 70 40 60 48 C56 52 53 56 50 58Z" fill={color} opacity=".5" />
    </svg>
  );
}

/* Shared royal atmosphere: same background for every show in the same time slot, with rays, sparks, stars & lotus */
export function RoyalStage({ drawTime, className = "", children, dense = false, testId }) {
  const v = vibeFor(drawTime);
  const sparks = React.useMemo(() => Array.from({ length: dense ? 16 : 9 }, (_, i) => ({ l: (i * 37 + 11) % 100, d: (i % 5) * 0.8, t: 3 + (i % 4) * 0.7, s: 0.5 + (i % 3) * 0.3 })), [dense]);
  const stars = React.useMemo(() => (v.stars ? Array.from({ length: 22 }, (_, i) => ({ l: (i * 43 + 7) % 100, t: (i * 29 + 5) % 70, d: (i % 6) * 0.5 })) : []), [v.stars]);
  return (
    <div className={`relative overflow-hidden text-white ${className}`} style={{ background: v.bg }} data-testid={testId} data-vibe={v.key}>
      <div className="absolute inset-0 pointer-events-none rl-rays" style={{ "--ray": v.ray }} />
      <div className="absolute -top-16 -right-10 w-48 h-48 rounded-full blur-3xl pointer-events-none" style={{ background: v.glow }} />
      {stars.map((s, i) => <span key={i} className="rl-star" style={{ left: `${s.l}%`, top: `${s.t}%`, animationDelay: `${s.d}s` }} />)}
      <div className="absolute inset-0 pointer-events-none">
        {sparks.map((s, i) => <span key={i} className="rl-spark" style={{ left: `${s.l}%`, animationDelay: `${s.d}s`, animationDuration: `${s.t}s`, transform: `scale(${s.s})` }} />)}
      </div>
      <Lotus className="absolute -bottom-2 -right-3 w-24 h-14 opacity-30 rl-lotus-float pointer-events-none" color={v.accent} />
      <div className="absolute inset-x-4 top-0 h-px pointer-events-none" style={{ background: `linear-gradient(90deg, transparent, ${v.accent}, transparent)` }} />
      <div className="relative">{children}</div>
    </div>
  );
}
